import React from "react";
import "../../styles/AboutUs.scss";
import FloatingBalls from "../../components/Background/FloatingBalls";

export default function AboutUs() {
  return (
    <div className="about-wrapper">
      <header className="about-header">
        <div className="header-bg" />       
        <div className="header-content">
            <h1 className="about-title cutout-text" data-text="About Us">About Us</h1>
            <h2 className="about-title cutout-text sub"  data-text="APLIC 2027">APLIC 2027</h2>
        </div>
      </header>

      <section className="about-section">
        <FloatingBalls />
        <div className="blur-overlay"></div>

        <div className="about-container">
          <h2 className="title">Asia Pacific Life Insurance Congress (APLIC)</h2>

          <p>
            The Asia Pacific Life Insurance Congress (APLIC) is the region’s premier
            gathering of life insurance professionals, leaders, and visionaries. Since
            its inception in 1978, APLIC has been a driving force for excellence in the
            life insurance industry — promoting professional growth, ethical leadership,
            and collaboration across Asia-Pacific markets.
          </p>

          <p>
            Held every two years, the Congress brings together thousands of delegates from
            member associations under the Asia Pacific Financial Services Association
            (APFinSA). Each edition showcases cutting-edge insights, breakthrough
            innovations, and best practices that shape the future of the life insurance
            profession.
          </p>

          <p>
            In 2027, the Philippines will proudly host the 21st Asia Pacific Life
            Insurance Congress — themed “Success in Motion: Innovate, Inspire, Impact.”
            This milestone event will celebrate the industry’s shared vision of progress,
            resilience, and leadership in an ever-evolving financial landscape.
          </p>

          <p>
            APLIC 2027 aims to empower agents and leaders to rise above challenges,
            embrace innovation, and create meaningful impact across communities throughout
            the Asia-Pacific region.
          </p>
        </div>
      </section>
    </div>
  );
}
